<template>
    <div id="add-stock-location-page">
        <div class="top-buttons">
            <ui5-button @click="$router.push('/settingsstocklocations')">
                {{ trans('pages.add_stock_location.back') }}
            </ui5-button>
        </div>
        <h3>{{ trans('pages.add_stock_location.title') }}</h3>
        <div class="form">
            <div class="field">
                <ui5-label
                    for="label"
                    required
                >
                    {{ trans('pages.add_stock_location.name') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    :readonly="success"
                    :value="inputData.label"
                    @input="inputData.label = $event.target.value"
                    id="label"
                />
                <div
                    class="error"
                    v-if="errors.label"
                >
                    {{ errors.label }}
                </div>
            </div>
            <div class="field">
                <ui5-label for="description">
                    {{ trans('pages.add_stock_location.description') }}
                </ui5-label>
                <ui5-textarea
                    id="description"
                    :value="inputData.description"
                    @input="inputData.description = $event.target.value"
                    :readonly="success"
                />
            </div>
            <div
                class="error"
                v-if="errors.other"
            >
                {{ errors.other }}
            </div>
            <div class="buttons">
                <ui5-button
                    v-if="success"
                    @click="reset"
                >
                    {{ trans('pages.add_stock_location.add_new_location') }}
                </ui5-button>
                <ui5-button
                    @click="add"
                    v-else
                >
                    {{ trans('pages.add_stock_location.add') }}
                </ui5-button>

                <ui5-button
                    @click="printLabel(success.ID, 'small')"
                    :disabled="!success"
                >
                    <div>
                        <spinner v-if="printing.small" />
                        <span>
                            {{
                                trans(
                                    'pages.add_stock_location.print_small_label'
                                )
                            }}
                        </span>
                    </div>
                </ui5-button>
                <ui5-button
                    @click="printLabel(success.ID, 'medium')"
                    :disabled="!success"
                >
                    <div>
                        <spinner v-if="printing.medium" />
                        <span>
                            {{
                                trans(
                                    'pages.add_stock_location.print_medium_label'
                                )
                            }}
                        </span>
                    </div>
                </ui5-button>
                <ui5-button
                    @click="printLabel(success.ID, 'large')"
                    :disabled="!success"
                >
                    <div>
                        <spinner v-if="printing.large" />
                        <span>
                            {{
                                trans(
                                    'pages.add_stock_location.print_large_label'
                                )
                            }}
                        </span>
                    </div>
                </ui5-button>
            </div>
        </div>
    </div>
</template>
<script>
import stockLocationApi from './../api/stockLocation';
import ErrorHelper from '../helpers/ErrorHelper';
import spinner from '../components/loader/Spinner';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: {
        spinner,
    },
    mixins: [localization],
    data() {
        return {
            success: null,
            inputData: {
                label: '',
                description: '',
            },
            printing: {
                small: false,
                medium: false,
                large: false,
            },
            errors: {
                label: null,
                description: null,
                other: null,
            },
        };
    },
    computed: {
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
            ]();
        },
    },
    methods: {
        printLabel(labelId, size) {
            this.printing[size] = true;
            stockLocationApi
                .printLabel(labelId, size, this.selectedPrinterPostParameter)
                .then(() => {
                    showInfoMessage(
                        this.trans('pages.add_stock_location.label_printed')
                    );
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans('pages.add_stock_location.print_failed', {
                            error: ErrorHelper.parseError(error.response.data),
                        })
                    );
                })
                .finally(() => {
                    this.printing[size] = false;
                });
        },
        reset() {
            this.success = null;
            this.errors = {
                label: null,
                description: null,
                other: null,
            };
            this.inputData.label = '';
            this.inputData.description = '';
        },
        add() {
            this.errors.label = null;
            this.errors.other = null;
            this.success = null;

            const label = this.inputData.label;
            if (!label || !label.length) {
                this.errors.label = this.trans(
                    'pages.add_stock_location.name_empty'
                );
                return;
            }

            const description = this.inputData.description;

            stockLocationApi
                .add(label, description)
                .then((response) => {
                    this.success = response.data.data;
                })
                .catch((error) => {
                    const response = error.response.data;
                    const parsed = ErrorHelper.parseError(response);
                    if (parsed == 'label.exists') {
                        showErrorMessage(
                            this.trans(
                                'pages.add_stock_location.location_exists'
                            )
                        );
                        this.errors.label = this.trans(
                            'pages.add_stock_location.name_not_unique'
                        );
                    } else {
                        this.errors.other = parsed;
                    }
                });
        },
    },
};
</script>
